// extracted by mini-css-extract-plugin
export default {"preWrapper":"styles_preWrapper__7PEm9"};